import React from 'react'
import * as d3 from 'd3'
import { useTranslation } from 'react-i18next'

import createBasicChart from '../../components/D3/createBasicChart'
import createD3Component from '../../components/D3/D3'

import styles from './InsightsPage.module.scss'

interface ChartData {
  inLibrary: number
  started: number
  finished: number
}

function chart(svg: SVGSVGElement) {
  const $svg = d3.select(svg)

  // Area
  const $area = $svg
    .append('path')
    .attr('class', styles.area)
    .attr('fill', 'url(#InsightsPageLearningInvestmentFunnelAreaGradient)')

  const $gradient = $svg
    .append('defs')
    .append('linearGradient')
    .attr('id', 'InsightsPageLearningInvestmentFunnelAreaGradient')
    .attr('x1', '100%')
    .attr('x2', 0)
    .attr('y1', 0)
    .attr('y2', 0)
  $gradient.append('stop').attr('offset', '0%').attr('stop-color', 'var(--primary-light)')
  $gradient.append('stop').attr('offset', '100%').attr('stop-color', 'white')

  function update({ data }: { data: ChartData }) {
    const svgSize = $svg.node()!.getBoundingClientRect()
    const rect = { left: 20, top: 20, width: svgSize.width - 40, height: svgSize.height - 40 }

    $area
      .datum(
        data.inLibrary
          ? ([
              [0, 1],
              [1, data.started / data.inLibrary],
              [2, data.finished / data.inLibrary],
            ] as [number, number][])
          : []
      )
      .attr(
        'd',
        d3
          .area()
          .x(([x]) => rect.left + (rect.width * x) / 2)
          .y0(([_, y]) => rect.top + rect.height / 2 + (rect.height / 2) * y)
          .y1(([_, y]) => rect.top + rect.height / 2 - (rect.height / 2) * y)
      )
  }

  return { update }
}

const ChartComponent = createD3Component(createBasicChart(chart), { className: styles.funnelD3 })

export default React.memo(function ({ data }: { data: ChartData }) {
  const { t } = useTranslation()

  return (
    <dl className={styles.InsightsPageLearningInvestmentFunnel}>
      <ChartComponent data={data} />
      <div className={styles.funnelSection}>
        <dt>{t('insights.number of booked or assigned courses')}</dt>
        <dd>{data.inLibrary}</dd>
      </div>
      <div className={styles.funnelSection}>
        <dt>{t('insights.number of courses started')}</dt>
        <dd>{data.started}</dd>
      </div>
      <div className={styles.funnelSection}>
        <dt>{t('insights.number of courses finished')}</dt>
        <dd>{data.finished}</dd>
      </div>
    </dl>
  )
})
